import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FoamFingerIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                d="M6 1a3 3 0 0 1 2.999 3l-.001 3H18a3 3 0 0 1 2.995 2.824L21 10v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3zm5.999 13.002L11.965 14l-3.933.002h-.033L7.965 14H5v6a1 1 0 0 0 .883.993L6 21h12a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-1.001l-.001 3L17 15.022a3 3 0 0 1-3 3H9.999a1 1 0 0 1 0-2H14a1 1 0 0 0 1-1V14l-2.968.002h-.033zM5.999 3A1 1 0 0 0 5 4v8h1.998V4a1 1 0 0 0-.882-.993zm5 6h-2l-.001 3h2V9zm4 0h-2l-.001 3h2V9z"
            />
        </svg>
    );
};
